import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-644fc103"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center place-content-center h-full w-full z-5" }
const _hoisted_2 = { class: "dialog p-4 text-center" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  class: "text-center",
  ref: "qrCodeContainer"
}
const _hoisted_5 = { class: "mt-8" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_motion_pop = _resolveDirective("motion-pop")!

  return (_openBlock(), _createElementBlock("div", {
    class: "absolute w-full bg-white bg-opacity-95 transition-opacity z-5",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.text), 1),
        _createElementVNode("div", _hoisted_4, null, 512),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("qrModal.orIfYouPrefer")), 1),
          _createElementVNode("a", {
            href: _ctx.url,
            target: "_blank",
            class: "py-2 px-3 text-sm font-semibold rounded-md shadow-lg focus:outline-none cursor-pointer transition-all bg-transparent border-2 border-superagent text-gray-700 hover:shadow-gray-700/30"
          }, _toDisplayString(_ctx.t("qrModal.continueOnComputer")), 9, _hoisted_7)
        ])
      ])), [
        [_directive_motion_pop]
      ])
    ])
  ], 4))
}